import { dateDifference } from '../../util';
export var EXPIRATION_OPTIONS = [
    { value: 1, label: '1 Day' },
    { value: 2, label: '2 Days' },
    { value: 3, label: '3 Days' },
    { value: 4, label: '4 Days' },
    { value: 5, label: '5 Days' },
    { value: 6, label: '6 Days' },
    { value: 7, label: '1 Week' },
    { value: 14, label: '2 Weeks' },
    { value: 21, label: '3 Weeks' },
    { value: 28, label: '4 Weeks' },
];
export function getExpirationData(el, now) {
    var _a;
    var diffHours = dateDifference(el.expirationTime, new Date(now), 'h');
    var diffDays = Math.floor(diffHours / 24);
    var diffWeeks = Math.floor(diffDays / 7);
    var hours = diffHours - diffDays * 24;
    var days = diffDays - diffWeeks * 7;
    var hasExpired = diffHours <= 0;
    var expiresIn = (_a = EXPIRATION_OPTIONS.find(function (o) { return o.value === diffDays; })) === null || _a === void 0 ? void 0 : _a.label;
    if (expiresIn !== undefined && hours !== 0) {
        expiresIn = expiresIn + ' and ' + hours + ' Hours';
    }
    if (expiresIn === undefined) {
        expiresIn = hasExpired
            ? 'Expired'
            : diffDays !== 0
                ? diffWeeks === 1
                    ? diffWeeks + ' Week, ' + days + ' Days and ' + hours + ' Hours'
                    : diffWeeks + ' Weeks, ' + days + ' Days and ' + hours + ' Hours'
                : hours + ' Hours';
    }
    return { expiresIn: expiresIn, hasExpired: hasExpired };
}
export function createEntryLinkPath(entryLinkKey) {
    return "".concat(window.location.origin, "/#/entrylink/").concat(entryLinkKey);
}
